/* Add-to-cart behaviour for the collection-page weight pills. */
(function () {
  'use strict';

  function setLabel(btn, text) {
    var price = btn.querySelector('.pill__price');
    if (price) {
      price.textContent = text;
    }
  }

  function readConfig() {
    var el = document.getElementById('cart-config');
    if (!el) {
      return {};
    }
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  /* Refresh the drawer contents, then open it the same way the theme's own
     cart trigger does. Falls back to a plain redirect when the shop is set
     to a page cart rather than the drawer. */
  function openCart() {
    var config = readConfig();
    var cart = window.Shopify && window.Shopify.theme && window.Shopify.theme.cart;
    var ajaxCart = window.Shopify && window.Shopify.theme && window.Shopify.theme.ajaxCart;

    if (!cart || !ajaxCart) {
      window.location.href = config.cart_url || '/cart';
      return;
    }

    return cart.getCart().then(function (state) {
      ajaxCart.updateView(config, state);

      if (config.cart_action === 'drawer') {
        ajaxCart.showDrawer(config);
      } else if (config.cart_action === 'modal_cart') {
        ajaxCart.showModal(config);
      } else {
        window.location.href = config.cart_url || '/cart';
      }
    });
  }

  function flash(btn, state) {
    btn.classList.remove('is-adding', 'is-added');
    btn.classList.add(state);
    if (state === 'is-added') {
      setTimeout(function () {
        btn.classList.remove('is-added');
      }, 1600);
    }
  }

  function addVariant(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.classList.contains('is-adding')) {
      return;
    }

    var original = btn.querySelector('.pill__price');
    var originalText = original ? original.textContent : '';

    btn.classList.add('is-adding');
    setLabel(btn, 'Adding\u2026');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || 'Could not add to cart');
          });
        }
        return res.json();
      })
      .then(function () {
        btn.classList.remove('is-adding');
        flash(btn, 'is-added');
        setLabel(btn, 'Added');
        openCart();
      })
      .catch(function (err) {
        btn.classList.remove('is-adding');
        setLabel(btn, 'Retry');
        setTimeout(function () {
          setLabel(btn, originalText);
        }, 1800);
        console.warn('[pill] add failed:', err.message);
      });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.js-add-variant');
    if (!btn) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    addVariant(btn);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }
    var btn = event.target.closest('.js-add-variant');
    if (!btn) {
      return;
    }
    event.preventDefault();
    addVariant(btn);
  });
})();
